import axios from "@/plugins/axios-common";

const string = ({ required } = {}) => {
    return (value) => {
        if (!value) {
            return required ? "Required" : true;
        }
        return true;
    };
};

const cardAsync = ({ required } = {}) => {
    return (value) => {
        if (!value) {
            return required ? "Required" : true;
        }
        return new Promise((resolve) => {
            const body = { searchString: value.replace(/\D+/g, '') }
            const settings = {
                method: 'POST',
                data: body,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            }
            axios("/client/card.json", settings).then(() => {
                resolve ('Значение поля карта недопустимо')
            }).catch(()=>{
                resolve ( true)
            })
        });
    };
};

const phoneAsync = ({ required } = {}) => {
    return (value) => {
        if (!value) {
            return required ? "Required" : true;
        }
        return new Promise((resolve) => {
            const body = { searchString: value.replace(/\D+/g, '') }
            const settings = {
                method: 'POST',
                data: body,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            }
            axios("/client/phone.json", settings).then(() => {
                resolve ('Значение поля номер телефона недопустимо')
            }).catch(()=>{
                resolve ( true)
            })
        });
    };
};

const plateNumber = () => {
    return (value) => {
        if (value && value.length > 0 && value.length < 7) {
            return 'Значение поля номер авто недопустимо'
        }
        return new Promise((resolve) => {
            const body = { searchString: value }
            const settings = {
                method: 'POST',
                credentials: "same-origin",
                data: body,
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                }
            }
            axios("/client/plate.json", settings).then(() => {
                resolve ('Значение поля номер авто недопустимо')
            }).catch(()=>{
                resolve ( true)
            })
        })
    }
}

const rules = {
    string,
    phoneAsync,
    cardAsync,
    plateNumber
};

export default rules;